import React, { useEffect, useState } from "react";
import "../../CSS/ItemMaster.css";
import axios from "axios";
import LoadingScreen from "../LoadingScreen";
import "jspdf-autotable";
import { FaArrowLeft } from "react-icons/fa";
import moment from "moment";
import { useSelector } from "react-redux";
import Select from "react-select";
import AllPagesNavbar from "../../Components/MasterNavbar/AllPagesMasterNavbar";
import ExcelJS from "exceljs";
import jsPDF from "jspdf";
import "jspdf-autotable";
import { BsFileEarmarkPdf } from "react-icons/bs";
import { RiFileExcel2Line } from "react-icons/ri";

const ListOfTrucksReadyForLoading = () => {
  const BASEURL_GLOBAL = process.env.REACT_APP_BASEURL_GLOBAL;
  const BASEURL = process.env.REACT_APP_BASEURL;
  const authToken = window.sessionStorage.getItem("auth-token");
  const sessionToken = window.sessionStorage.getItem("session-token");
  const [isloading, setisloading] = useState(true);
  const [search, setSearch] = useState("");
  const state = useSelector((state) => state.changeTheState.user);
  const user = state.emailId?.split("@")[0]?.toUpperCase();
  const [vehiclesList, setVehiclesList] = useState([]);
  const [showGateIn, setShowGateIn] = useState(false);
  const [date, setDate] = useState(new Date().toISOString());
  const [vehicleNo, setVehicleNo] = useState("");
  const [clientsList, setClientsList] = useState([]);
  const [returnsClient, setreturnsClient] = useState("");
  const [returnsClientCode, setReturnsClientCode] = useState("");
  const [returnsProduct, setReturnsProduct] = useState("");
  const [returnsProductCode, setReturnsProductCode] = useState("");
  const [productsList, setProductsList] = useState([]);
  const [returnsQty, setReturnsQty] = useState("");
  const [returnsPoNo, setReturnsPoNo] = useState("");

  const [adviceNo, setAdviceNo] = useState("");
  const [firstAdviceNo, setFirstAdviceNo] = useState("");
  const [lastAdviceNo, setLastAdviceNo] = useState("");
  const [adviceDate, setAdviceDate] = useState(new Date().toISOString());
  const [routeFrom, setRouteFrom] = useState("");
  const [routeTo, setRouteTo] = useState("");
  const [routeId, setRouteId] = useState("");
  const [uom, setUom] = useState("");
  const [mill, setMill] = useState("");
  const [routeList, setRoutList] = useState([]);

  const [selLocations, setSelLocations] = useState([]);
  const [locationOptions, setLocationOptions] = useState([]);

  const [selDestination, setSelDestination] = useState([]);
  const [destinationOptions, setDestinationOptions] = useState([]);

  const [selectedRowIndex, setSelectedRowIndex] = useState(null);
  const [showTable, setShowTable] = useState(false);

  const [tableData, setTableData] = useState([]); // All products prefilled
  const [selectedProducts, setSelectedProducts] = useState([]); // Final selected rows

  const [currentTime, setCurrentTime] = useState(
    new Date().toLocaleTimeString(),
  );

  const [driversList, setDriversList] = useState([]);
  const [driverName, setDriverName] = useState("");
  const [driverCode, setDriverCode] = useState("");
  const [department, setDepartment] = useState("");
  const [destinationList, setDestinationList] = useState([]);
  const [destination, setDestination] = useState("");

  const [loadingAdviceData, setLoadingAdviceData] = useState([]);
  const [showDoc, setShowDoc] = useState(false);
  const [searchLoading, setSearchLoading] = useState("");
  const [isCancelled, setIsCancelled] = useState(false);
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [forRawMaterials, setForRawMaterials] = useState(false);
  const [dispatchData, setDispatchData] = useState([])
  const [hist, setHist] = useState(false);

  const VehicleDepartment = useSelector(
    (state) => state?.VehicleDepartmentReducer,
  );

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentTime(new Date().toLocaleTimeString());
    }, 1000);

    return () => clearInterval(interval);
  }, []);

  const filteredRequest = loadingAdviceData?.sort((a,b)=> b.OT_LOADING_ADVISE_NO - a.OT_LOADING_ADVISE_NO).filter((item) => {
    const searchData = searchLoading.toLowerCase().split(" ").filter(Boolean);

    const sDate = new Date(item.OT_LOADING_ADVISE_DATE);
    const eDate = new Date(item.OT_LOADING_ADVISE_DATE);

    const startDates = startDate ? new Date(startDate) : null;

    const endDates = endDate ? new Date(endDate) : null;

    if (searchData.length === 0 && !startDate && !endDate) {
      return true;
    }

    const driver = driversList?.find(
      (value) => value?.DRIVERCODE === item?.OT_LOADING_ADVISE_DRIVER_CODE,
    );

    const textMatch = searchData.every((term) => {
      const driverMatch =
        driver?.DRIVERNAME?.toLowerCase()?.includes(term) ?? false;

      const otherMatch = [
        "OT_LOADING_ADVISE_NO",
        "OT_LOADING_ADVISE_VEHICLE_NO",
        "OT_LOADING_ADVISE_CLIENT_PO_NO",
        "OT_LOADING_ADVISE_FROM_MILL",
        "OT_LOADING_ADVISE_PRODUCT_DESTINATION",
      ].some((key) => {
        const columnValue = String(item[key] || "").toLowerCase();
        return columnValue.includes(term);
      });

      return driverMatch || otherMatch;
    });

    const dateMatch =
      (!startDates || sDate >= startDates) && (!endDates || eDate <= endDates);

    return textMatch && dateMatch;
  });

  const filteredData = vehiclesList.filter((item) => {
    const searchData = search.toLowerCase().split(" ").filter(Boolean);

    if (searchData.length === 0 && !department) {
      return true;
    }

    const textMatch = searchData.every((term) => {
      return [
        "VEHICLE REG NO",
        "DRIVERNAME",
        "MAKE",
        "MODEL",
        "TRAILER NAME ATTACHED",
      ].some((key) => {
        const columnValue = String(item[key]).toLowerCase();
        return columnValue.includes(term);
      });
    });

    const departmentFilter = !department || item?.DEPARTMENT === department;

    return textMatch && departmentFilter;
  });

  const updateTableField = (index, field, value) => {
    setTableData((prev) => {
      const updated = [...prev];
      if (!updated[index]) {
        updated[index] = {}; // create row object if missing
      }
      updated[index][field] = value;
      return updated;
    });
  };
  const handleRowCheck = (e, itemCode) => {
    if (e.target.checked) {
      setSelectedProducts((prev) => [...prev, { code: itemCode }]);
    } else {
      setSelectedProducts((prev) =>
        prev.filter((item) => item.code !== itemCode),
      );
    }
  };

  useEffect(() => {
    initialData();
  }, []);

  async function getNewId() {
    try {
      const response = await axios.get(
        `${BASEURL_GLOBAL}/globalViewHandler?viewname=1096`,
        {
          headers: {
            "auth-token": authToken,
            "session-token": sessionToken,
          },
        },
      );

      if (response?.status === 201) {
        setAdviceNo(response?.data[0]?.NEWID);
        setLastAdviceNo(response?.data[0]?.NEWID);
      } else {
        console.error("Error fetching New Id details:");
        setisloading(false);
      }
    } catch (err) {
      console.error("Error fetching Charges details:", err);
      setisloading(false);
    }
  }

  const initialData = async () => {
    await getNewId();
    //   Route's List
    axios
      .get(`${BASEURL_GLOBAL}/globalViewHandler?viewname=524`, {
        headers: {
          "auth-token": authToken,
          "session-token": sessionToken,
        },
      })
      .then((response) => {
        setRoutList(response?.data);
      })
      .catch((error) => {
        setisloading(false);
        console.error("Error fetching Route Details:", error);
      });

    // Client's List
    axios
      .get(`${BASEURL_GLOBAL}/globalViewHandler?viewname=599`, {
        headers: {
          "auth-token": authToken,
          "session-token": sessionToken,
        },
      })
      .then((response) => {
        //    "CLIENTCODE": "2",
        // "CLIENTNAME": "WESTERN REGION",
        setClientsList(response?.data);
      })
      .catch((error) => {
        setisloading(false);
        console.error("Error fetching Client Details:", error);
      });

    //   Items List
    axios
      .get(`${BASEURL_GLOBAL}/globalViewHandler?viewname=625`, {
        headers: {
          "auth-token": authToken,
          "session-token": sessionToken,
        },
      })
      .then((response) => {
        const filter = response?.data?.filter(
          (item) =>
            item.OM_ITEM_FINISHED_RAW_MATERIAL === "F" &&
            item?.DEPARTMENT === "LOGISTICS",
        );
        setProductsList(filter);
        //    "OM_ITEM_FINISHED_RAW_MATERIAL": "F",
        // "ITEMCODE": "8",
        // "MAINNAME": "Dunia Home Baking",
      })
      .catch((error) => {
        setisloading(false);
        console.error("Error fetching Item Details:", error);
      });

    //   Mills List
    axios
      .get(`${BASEURL_GLOBAL}/globalViewHandler?viewname=1291`, {
        headers: {
          "auth-token": authToken,
          "session-token": sessionToken,
        },
      })
      .then((response) => {
        const list = response?.data?.map((item) => ({
          value: item.LOCATIONNAME,
          label: item.LOCATIONNAME,
        }));
        setLocationOptions(list);
      })
      .catch((error) => {
        setisloading(false);
        console.error("Error fetching Item Details:", error);
      });

    // Driver's List  345;
    axios
      .get(`${BASEURL_GLOBAL}/globalViewHandler?viewname=345`, {
        headers: {
          "auth-token": authToken,
          "session-token": sessionToken,
        },
      })
      .then((response) => {
        setDriversList(response?.data);
      })
      .catch((error) => {
        setisloading(false);
        console.error("Error fetching Driver details:", error);
      });

    axios
      .get(`${BASEURL_GLOBAL}/globalViewHandler?viewname=1242`, {
        headers: {
          "auth-token": authToken,
          "session-token": sessionToken,
        },
      })
      .then((response) => {
        const list = response?.data?.map((item) => ({
          value: item.OM_CITY_DESCRIPTION,
          label: item.OM_CITY_DESCRIPTION,
        }));
        setDestinationOptions(list);
      })
      .catch((error) => {
        setisloading(false);
        console.error("Error fetching Driver details:", error);
      });

    // Loading Advice Data
    axios
      .get(`${BASEURL_GLOBAL}/globalViewHandler?viewname=1089`, {
        headers: {
          "auth-token": authToken,
          "session-token": sessionToken,
        },
      })
      .then((response) => {
        setDispatchData(response?.data)
        const dispatchOrderNos = response?.data?.map(
          (item) => item.OT_DISPATCH_LOADING_ORDER_NO,
        );
        axios
          .get(`${BASEURL_GLOBAL}/globalViewHandler?viewname=1095`, {
            headers: {
              "auth-token": authToken,
              "session-token": sessionToken,
            },
          })
          .then((res) => {
            // const filteredData = res.data.filter(
            //   (item) => !dispatchOrderNos.includes(item.OT_LOADING_ADVISE_NO),
            // );
            // console.log(filteredData)
            const sortedData = [...(res.data || [])].sort(
              (a, b) =>
                Number(b.OT_LOADING_ADVISE_NO) - Number(a.OT_LOADING_ADVISE_NO),
            );
            axios
              .get(`${BASEURL_GLOBAL}/globalViewHandler?viewname=1269`, {
                headers: {
                  "auth-token": authToken,
                  "session-token": sessionToken,
                },
              })
              .then((response) => {
                const fromMillMap = response?.data.reduce((acc, item) => {
                  const adviseNo = item.OT_LOADING_ADVISE_NO;

                  if (!adviseNo) return acc;

                  if (!acc[adviseNo]) {
                    acc[adviseNo] = new Set();
                  }

                  if (item.OT_LOADING_ADVISE_FROM_MILL) {
                    acc[adviseNo].add(item.OT_LOADING_ADVISE_FROM_MILL);
                  }

                  return acc;
                }, {});

                const destinationMap = response?.data.reduce((acc, item) => {
                  const adviseNo = item.OT_LOADING_ADVISE_NO;

                  if (!adviseNo) return acc;

                  if (!acc[adviseNo]) {
                    acc[adviseNo] = new Set();
                  }

                  if (item.OT_LOADING_ADVISE_PRODUCT_DESTINATION) {
                    acc[adviseNo].add(
                      item.OT_LOADING_ADVISE_PRODUCT_DESTINATION,
                    );
                  }

                  return acc;
                }, {});

                const mergedResult = sortedData
                  .map((vehicle) => {
                    const adviseNo = vehicle.OT_LOADING_ADVISE_NO;

                    return {
                      ...vehicle,
                      OT_LOADING_ADVISE_FROM_MILL: fromMillMap[adviseNo]
                        ? Array.from(fromMillMap[adviseNo]).join(", ")
                        : null,
                      OT_LOADING_ADVISE_PRODUCT_DESTINATION: destinationMap[
                        adviseNo
                      ]
                        ? Array.from(destinationMap[adviseNo]).join(", ")
                        : null,
                    };
                  })
                  .filter(Boolean);

                setLoadingAdviceData(mergedResult);
                const sortedDatas = mergedResult?.sort(
                  (a, b) => a?.OT_LOADING_ADVISE_NO - b?.OT_LOADING_ADVISE_NO,
                );
                setFirstAdviceNo(sortedDatas?.[0]?.OT_LOADING_ADVISE_NO);
              })
              .catch((error) => {
                setisloading(false);
                console.error("Error fetching 1269 details:", error);
              });
          })
          .catch((error) => {
            setisloading(false);
            console.error("Error fetching Loading Advice Data:", error);
          });
      })
      .catch((error) => {
        setisloading(false);
        console.error("Error fetching Loading Advice Data:", error);
      });

    axios
      .get(`${BASEURL_GLOBAL}/globalViewHandler?viewname=671`, {
        headers: {
          "auth-token": authToken,
          "session-token": sessionToken,
        },
      })
      .then((response) => {
        if (VehicleDepartment !== "") {
          const filterData = response?.data?.filter(
            (item) =>
              item.VEHICLESTATE === "SENT TO LOAD" &&
              item?.DEPARTMENT === VehicleDepartment,
          );
          setVehiclesList(filterData);
          // if (filterData?.length === 0) {
          //   setShowGateIn(true);
          // }
        } else {
          const filterData = response?.data?.filter(
            (item) => item.VEHICLESTATE === "SENT TO LOAD",
          );
          setVehiclesList(filterData);
          if (filterData?.length === 0) {
            setShowGateIn(true);
          }
        }
        setisloading(false);
      })
      .catch((error) => {
        setisloading(false);
        console.error("Error fetching Charges details:", error);
      });
  };

  console.log(loadingAdviceData);

  function getChildData(docno) {
    axios
      .get(
        `${BASEURL_GLOBAL}/globalViewHandler?viewname=1269&OT_LOADING_ADVISE_NO=${docno}`,
        {
          headers: {
            "auth-token": authToken,
            "session-token": sessionToken,
          },
        },
      )
      .then((response) => {
        const data = response.data || [];

        // 🔹 Extract FROM_MILL values
        const dispatchLocations = data
          .map((item) => item.OT_LOADING_ADVISE_FROM_MILL)
          .filter(Boolean);

        // 🔹 Extract FROM_MILL values
        const destinations = data
          .map((item) => item.OT_LOADING_ADVISE_PRODUCT_DESTINATION)
          .filter(Boolean);

        setSelLocations(dispatchLocations);
        setSelDestination(destinations);
      })
      .catch((error) => {
        setisloading(false);
        console.error("Error fetching Driver details 1269", error);
      });
  }

  async function SaveGateIn() {
    setisloading(true);
    try {
      const response = await axios.post(
        `${BASEURL_GLOBAL}/globalSpHandler?spname=1098`,
        {
          OT_LOADING_ADVISE_NO: Number(adviceNo),
          OT_LOADING_ADVISE_DATE: moment(adviceDate).format("YYYY/MM/DD"),
          OT_LOADING_ADVISE_ROUTE_NO: "",
          // OT_LOADING_ADVISE_ROUTE_NO: routeId,
          OT_LOADING_ADVISE_VEHICLE_NO: vehicleNo ? vehicleNo :"",
          OT_LOADING_ADVISE_CLIENT_CODE: "",
          // OT_LOADING_ADVISE_CLIENT_CODE: returnsClientCode
          //   ? returnsClientCode
          //   : "",
          OT_LOADING_ADVISE_PRODUCT_CODE: "",
          OT_LOADING_ADVISE_PRODUCT_QTY: 0,
          OT_LOADING_ADVISE_CLIENT_PO_NO: returnsPoNo ? returnsPoNo :"",
          OT_LOADING_ADVISE_PRODUCT_UOM: "",
          OT_LOADING_ADVISE_FROM_MILL: "",
          OT_LOADING_ADVISE_PROCESSED_BY: user,
          OT_LOADING_ADVISE_PROCESSED_DATE: date,
          OT_LOADING_ADVISE_DRIVER_CODE: driverCode ? driverCode: "",
          OT_LOADING_ADVISE_NEW_EXISTING: hist === true ? "EXISTING" : "NEW",
        },
        {
          headers: {
            "auth-token": authToken,
            "session-token": sessionToken,
          },
        },
      );

      if (response.status === 201) {
        if (forRawMaterials === false) {
          await SaveChild(response?.data?.message);
        } else {
          await SaveChildWithoutLocation(response?.data?.message);
        }
        // setisloading(false);
        // console.log(`Loading Advice Saved successfully`);
        // alert(`Loading Advice Saved successfully`);
      } else {
        setisloading(false);
        console.error(`Error while saving Loading Advice`);
      }
    } catch (error) {
      setisloading(false);
      console.error(`Error while saving Loading Advice`, error);
    }
  }

  async function SaveChild(docNo) {
    setisloading(true);
    let successCount = 0;
    let successMessage = null;
    let errorCount = 0;
    let errorMessage = null;
    for (let i = 0; i < selLocations.length; i++) {
      for (let j = 0; j < selDestination.length; j++) {
        const dispLoc = selLocations[i];
        const dest = selDestination[j];
        try {
          const response = await axios.post(
            `${BASEURL_GLOBAL}/globalSpHandler?spname=1270`,
            {
              OT_LOADING_ADVISE_NO: Number(docNo),
              OT_LOADING_ADVISE_ROUTE_NO: "",
              OT_LOADING_ADVISE_CLIENT_CODE: "",
              OT_LOADING_ADVISE_PRODUCT_CODE: "",
              OT_LOADING_ADVISE_PRODUCT_QTY: 0,
              OT_LOADING_ADVISE_CLIENT_PO_NO: "",
              OT_LOADING_ADVISE_PRODUCT_UOM: "",
              OT_LOADING_ADVISE_FROM_MILL: dispLoc,
              OT_LOADING_ADVISE_DESTINATION: dest,
            },
            {
              headers: {
                "auth-token": authToken,
                "session-token": sessionToken,
              },
            },
          );

          if (response.status === 201) {
            successCount++;
            successMessage = response.data.message;
          } else {
            errorCount++;
            errorMessage = response.data.message;
          }
        } catch (error) {
          setisloading(false);
          console.error(`Error while Saving Loading Advice Details`, error);
          alert(error.response.data.message);
        }
      }
    }
    setisloading(false);
    if (
      successCount == Number(selLocations.length * selDestination.length) &&
      successMessage
    ) {
      // alert("Loading Advice Details Saved Successfully");
      await SaveVehicleState(docNo);
    }
    if (errorMessage) {
      alert(`Error while Saving Loading Advice Details`, errorMessage);
    }
  }

  // Save Child without Location
  async function SaveChildWithoutLocation(docNo) {
    setisloading(true);
    let successCount = 0;
    let successMessage = null;
    let errorCount = 0;
    let errorMessage = null;
    for (let j = 0; j < selDestination.length; j++) {
      const dest = selDestination[j];
      try {
        const response = await axios.post(
          `${BASEURL_GLOBAL}/globalSpHandler?spname=1270`,
          {
            OT_LOADING_ADVISE_NO: Number(docNo),
            OT_LOADING_ADVISE_ROUTE_NO: "",
            OT_LOADING_ADVISE_CLIENT_CODE: "",
            OT_LOADING_ADVISE_PRODUCT_CODE: "",
            OT_LOADING_ADVISE_PRODUCT_QTY: 0,
            OT_LOADING_ADVISE_CLIENT_PO_NO: "",
            OT_LOADING_ADVISE_PRODUCT_UOM: "",
            OT_LOADING_ADVISE_FROM_MILL: "",
            OT_LOADING_ADVISE_DESTINATION: dest,
          },
          {
            headers: {
              "auth-token": authToken,
              "session-token": sessionToken,
            },
          },
        );

        if (response.status === 201) {
          successCount++;
          successMessage = response.data.message;
        } else {
          errorCount++;
          errorMessage = response.data.message;
        }
      } catch (error) {
        setisloading(false);
        console.error(`Error while Saving Loading Advice Details`, error);
        alert(error.response.data.message);
      }
    }

    setisloading(false);
    if (successCount == Number(selDestination.length) && successMessage) {
      // alert("Loading Advice Details Saved Successfully");
      await SaveVehicleState(docNo);
    }
    if (errorMessage) {
      alert(`Error while Saving Loading Advice Details`, errorMessage);
    }
  }

  async function SaveVehicleState(docNo) {
    setisloading(true);
    try {
      const response = await axios.post(
        `${BASEURL_GLOBAL}/globalSpHandler?spname=1053`,
        {
          OT_VEHICLE_REG_NO: vehicleNo,
          OT_VEHICLE_STATE:
            forRawMaterials === true ? "DISPATCHED" : "SEND TO DISPATCH",
          OT_VEHICLE_STATE_DATE: moment(date).format("YYYY/MM/DD"),
          OT_VEHICLE_STATE_TIME: currentTime,
          OT_VEHICLE_PREVIOUS_STATE: "SENT TO LOAD",
          OT_VEHICLE_STATE_UPDATED_BY: user,
        },
        {
          headers: {
            "auth-token": authToken,
            "session-token": sessionToken,
          },
        },
      );

      if (response.status === 201) {
        setisloading(false);
        await SaveState(docNo);
        // alert(`Vehicle State Updated successfully`);
        console.log(`Vehicle State Updated successfully`);
      } else {
        setisloading(false);
        console.error(`Error while saving Vehicle State`);
      }
    } catch (error) {
      setisloading(false);
      console.error(`Error while saving Vehicle State `, error);
    }
  }

  async function SaveState(docNo) {
    setisloading(true);
    try {
      const response = await axios.post(
        `${BASEURL_GLOBAL}/globalSpHandler?spname=1121`,
        {
          TRANSTYPE:
            forRawMaterials === true ? "DISPATCHED" : "SEND TO DISPATCH",
          DOC_NO: Number(docNo),
        },
        {
          headers: {
            "auth-token": authToken,
            "session-token": sessionToken,
          },
        },
      );

      if (response.status === 201) {
        setisloading(false);
        alert(`Loading Advice Saved successfully`);
        // alert(`State Updated successfully`);
        console.log(`State Updated successfully`);
      } else {
        setisloading(false);
        console.error(`Error while saving State`);
      }
    } catch (error) {
      setisloading(false);
      console.error(`Error while saving State `, error);
    }
  }

  // ********************* Cancel *************************
  async function CancelLoading() {
    setisloading(true);
    try {
      const response = await axios.post(
        `${BASEURL_GLOBAL}/globalSpHandler?spname=1321`,
        {
          OT_LOADING_ADVISE_NO: Number(adviceNo),
          OT_LOADING_ADVISE_CANCEL_BY: user,
        },
        {
          headers: {
            "auth-token": authToken,
            "session-token": sessionToken,
          },
        },
      );

      if (response.status === 201) {
        setisloading(false);
        alert(`Loading Advice Cancelled successfully`);
      } else {
        setisloading(false);
        console.error(`Error while Cancelled Loading Advice`);
      }
    } catch (error) {
      setisloading(false);
      console.error(`Error while Cancelled Loading Advice`, error);
    }
  }

  const handleRowClick = async (value, index) => {
    await getNewId();
    setDriverName(value["DRIVERNAME"]);
    const driver = driversList?.find(
      (item) => item?.DRIVERNAME === value?.DRIVERNAME,
    );
    setDriverCode(driver?.DRIVERCODE);
    setVehicleNo(value["VEHICLE REG NO"]);
    // fetchLastGateInNo(value?.OT_VEHICLE_REG_NO);
    setShowGateIn(true);
  };

  const handleSelectChange = (selectedOptions) => {
    const selectedValues = selectedOptions
      .map((option) => option.value)
      .filter((value) => value && value.trim() !== "");
    setSelLocations(selectedValues);
  };

  const handleDestinationChange = (selectedOptions) => {
    const selectedValues = selectedOptions
      .map((option) => option.value)
      .filter((value) => value && value.trim() !== "");
    setSelDestination(selectedValues);
  };

  // *************** EXPORT TO EXCEL OR PDF ****************************
  const ExcelStockData = () => {
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet("LOADING ORDER");
    const rows = document.querySelectorAll(".table_1 tbody tr");

    const columnWidths = [10, 10, 15, 25, 25, 10, 35, 35];

    // Set column widths for the worksheet
    columnWidths.forEach((width, index) => {
      worksheet.getColumn(index + 1).width = width;
    });

    // Add headers
    const headerRow = worksheet.addRow([
      "SNO",
      "DOC NO",
      "LOADING DATE",
      "VEHICLE",
      "DRIVER NAME",
      "ORDER NO",
      "DISPATCH LOCATIONS",
      "DESTINATIONS",
    ]);
    headerRow.eachCell((cell) => {
      cell.font = { bold: true };
    });

    // Add rows from the table
    rows.forEach((row) => {
      const rowData = [];
      row.querySelectorAll("td").forEach((cell) => {
        rowData.push(cell.textContent);
      });
      worksheet.addRow(rowData);
    });

    // Create a blob from the workbook
    workbook.xlsx.writeBuffer().then((buffer) => {
      const blob = new Blob([buffer], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.download = "LOADING_ORDER.xlsx";
      link.click();
    });
  };

  const PdfStockData = () => {
    const doc = new jsPDF();

    doc.text("LOADING_ORDER - Report", 10, 10);

    const columns = [
      "SNO",
      "DOC NO",
      "LOADING DATE",
      "VEHICLE",
      "DRIVER NAME",
      "ORDER NO",
      "DISPATCH LOCATIONS",
      "DESTINATIONS",
    ];

    const data = filteredRequest.map((stock, index) => {
      const driver = driversList?.find(
        (item) => item?.DRIVERCODE === stock?.OT_LOADING_ADVISE_DRIVER_CODE,
      );
      return [
        index + 1,
        stock.OT_LOADING_ADVISE_NO,
        stock.OT_LOADING_ADVISE_DATE
          ? moment(stock.OT_LOADING_ADVISE_DATE).format("DD/MM/YYYY")
          : "",
        stock.OT_LOADING_ADVISE_VEHICLE_NO,
        driver?.DRIVERNAME,
        stock.OT_LOADING_ADVISE_CLIENT_PO_NO,
        stock.OT_LOADING_ADVISE_FROM_MILL,
        stock.OT_LOADING_ADVISE_PRODUCT_DESTINATION,
      ];
    });

    doc.autoTable({
      head: [columns],
      body: data,
      startY: 20,
      showHead: "firstPage",
    });

    doc.save("LOADING_ORDER.pdf");
  };

  const handleButtonClick = (action) => {
    let adviceNoToPass;
    switch (action) {
      case "first":
        adviceNoToPass = Number(firstAdviceNo);
        break;
      case "decrement":
        adviceNoToPass = Number(adviceNo) - 1;
        if (adviceNoToPass < Number(firstAdviceNo)) {
          alert("Cannot decrement further");
          return;
        }
        break;

      case "increment":
        adviceNoToPass = Number(adviceNo) + 1;
        if (adviceNoToPass >= Number(lastAdviceNo)) {
          alert("No Further PO number");
          return;
        }
        break;

      case "latest":
        adviceNoToPass = Number(lastAdviceNo) - 1;
        break;
      default:
        break;
    }

    setAdviceNo(adviceNoToPass);
    getNavData(adviceNoToPass);
  };

  async function getNavData(docNo) {
    const item = loadingAdviceData?.find(
      (value) => value?.OT_LOADING_ADVISE_NO === docNo,
    );

    if (item) {
      setAdviceNo(item.OT_LOADING_ADVISE_NO);
      setAdviceDate(item.OT_LOADING_ADVISE_DATE);
      setVehicleNo(item.OT_LOADING_ADVISE_VEHICLE_NO);
      setReturnsPoNo(item.OT_LOADING_ADVISE_CLIENT_PO_NO);
      setIsCancelled(item.OT_LOADING_ADVISE_CANCELLED === true ? true : false);
      setSelLocations(item?.OT_LOADING_ADVISE_FROM_MILL);
      setSelDestination(item?.OT_LOADING_ADVISE_PRODUCT_DESTINATION);
      setDriverCode(item?.OT_LOADING_ADVISE_DRIVER_CODE);
      const driver = driversList?.find(
        (value) => value?.DRIVERCODE === item?.OT_LOADING_ADVISE_DRIVER_CODE,
      );
      setDriverName(driver?.DRIVERNAME);
      getChildData(item.OT_LOADING_ADVISE_NO);
      setHist(true)
    } else {
      // Auto-decrement if record not found
      const allVouchers = [...(loadingAdviceData || [])]
        .map((item) => Number(item?.OT_LOADING_ADVISE_NO))
        .sort((a, b) => a - b);

      const currentAdviceNo = Number(docNo);

      // Determine whether this was likely an increment or decrement action
      const lastAdviceNos = Number(adviceNo);

      const isIncrement = currentAdviceNo > lastAdviceNos;

      if (isIncrement) {
        // Find next existing record greater than the current one
        const nextExisting = allVouchers.find((num) => num > currentAdviceNo);
        if (nextExisting !== undefined) {
          console.warn(`docNo No ${docNo} not found, trying ${nextExisting}`);
          await getNavData(nextExisting);
          return;
        } else {
          alert(`No further docNo No found after ${docNo}`);
        }
      } else {
        const previousExisting = [...allVouchers]
          .reverse()
          .find((num) => num < Number(docNo));

        if (previousExisting !== undefined) {
          console.warn(
            `docNo No ${docNo} not found, trying ${previousExisting}`,
          );
          await getNavData(previousExisting);
          return;
        } else {
          alert(`No existing docNo No found before ${docNo}`);
        }
      }
    }
  }

  if (isloading) {
    return <LoadingScreen />;
  }

  return (
    <div className="min-h-screen">
      <AllPagesNavbar />
      <div className="flex justify-between">
        <h1 className="lg:text-3xl font-extrabold underline text-blue-600">
          List Of Trucks Ready For Loading
        </h1>
        {/* <FaArrowLeft
          className="cursor-pointer hover:text-blue-300 transition-all"
          size={30}
          onClick={() => {
            window.history.back();
          }}
        /> */}
      </div>

      <div className="select_product_type" style={{ marginTop: "5px" }}>
        <div>
          <p>Search</p>
        </div>
        <div>
          <input
            type="text"
            className="w-64 h-8 border border-black rounded-md"
            value={search}
            onChange={(e) => {
              setSearch(e.target.value);
            }}
          ></input>
        </div>
        <p className=" lg:ml-2">Department :</p>
        <Select
          className="lg:w-64 w-64 lg:ml-2"
          menuPortalTarget={document.body}
          styles={{
            menuPortal: (base) => ({ ...base, zIndex: 9999 }),
            menu: (base) => ({ ...base, zIndex: 9999 }),
          }}
          value={
            department
              ? { value: department, label: department }
              : { value: "", label: "Select Department" }
          }
          onChange={(e) => {
            setDepartment(e.value);
          }}
          options={[
            { value: "", label: "Select Department" },
            ...Array.from(
              new Set(vehiclesList?.map((item) => item.DEPARTMENT)),
            ).map((dept) => ({
              value: dept,
              label: dept,
            })),
          ]}
        ></Select>
      </div>

      <div className="visible lg:h-[500px] p-1 z-0 lg:overflow-auto mt-2">
        <table className="w-full border border-gray-300 text-sm">
          <thead className="sticky top-0">
            <tr className="bg-[#2b3f5c] text-white text-[12px]">
              <td className="py-2 px-4 text-right border border-gray-300">
                SNO
              </td>
              <td className="py-2 px-4 text-left border border-gray-300">
                VEHICLE REG NO
              </td>
              <td className="py-2 px-4 text-left border border-gray-300">
                DRIVER NAME
              </td>
              <td className="py-2 px-4 text-left border border-gray-300">
                MAKE
              </td>
              <td className="py-2 px-4 text-left border border-gray-300">
                MODEL
              </td>
              <td className="py-2 px-4 text-left border border-gray-300">
                TRAILER ATTACHED ?
              </td>
              <td className="py-2 px-4 text-left border border-gray-300">
                ATTACHED NAME TRAILER
              </td>
            </tr>
          </thead>
          <tbody>
            {filteredData.map((value, index) => (
              <tr
                key={index}
                className="hover:bg-gray-100 cursor-pointer text-[13px]"
                onClick={() => handleRowClick(value, index)}
              >
                <td className="py-2 px-4 text-right border border-gray-300">
                  {index + 1}
                </td>
                <td className="py-2 px-4 text-left border border-gray-300">
                  {value["VEHICLE REG NO"] || "N/A"}
                </td>
                <td className="py-2 px-4 text-left border border-gray-300">
                  {value["DRIVERNAME"] || "N/A"}
                </td>
                <td className="py-2 px-4 text-left border border-gray-300">
                  {value.MAKE || "N/A"}
                </td>
                <td className="py-2 px-4 text-left border border-gray-300">
                  {value.MODEL || "N/A"}
                </td>
                <td className="py-2 px-4 text-left border border-gray-300">
                  {value["TRAILER ATTACHED"] === true
                    ? "YES"
                    : value["TRAILER ATTACHED"] === false
                      ? "NO"
                      : "N/A"}
                </td>
                <td className="py-2 px-4 text-left border border-gray-300">
                  {value["TRAILER NAME ATTACHED"] || "N/A"}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* PopUp */}
      {showGateIn && (
        <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 z-[100] bg-white border border-black lg:h-[500px] h-[80%] lg:w-[1080px] w-[95%] p-1 overflow-y-auto rounded-md">
          <h1 className="lg:text-3xl font-bold flex justify-start">
            TRUCKS READY FOR LOADING
          </h1>

          <div className="flex lg:ml-2 gap-1 lg:mr-2">
            <button
              className="flex h-7 items-center justify-center px-3 py-1 border border-black bg-[#002d62] text-white outline-none transition duration-200 ease-in-out hover:border-gray-700 focus:ring focus:border-blue-300 mb-[1px]"
              onClick={() => {
                handleButtonClick("first");
              }}
            >
              {"<<"}
            </button>
            <button
              className="flex h-7 items-center justify-center px-3 py-1 border border-black bg-[#002d62] text-white outline-none transition duration-200 ease-in-out hover:border-gray-700 focus:ring focus:border-blue-300 mb-[1px]"
              onClick={() => {
                handleButtonClick("decrement");
              }}
            >
              {"<"}
            </button>
            <button
              className="flex h-7 items-center justify-center px-3 py-1 border border-black bg-[#002d62] text-white outline-none transition duration-200 ease-in-out hover:border-gray-700 focus:ring focus:border-blue-300 mb-[1px]"
              onClick={() => {
                handleButtonClick("increment");
              }}
            >
              {">"}
            </button>
            <button
              className="flex h-7 items-center justify-center px-3 py-1 border border-black bg-[#002d62] text-white outline-none transition duration-200 ease-in-out hover:border-gray-700 focus:ring focus:border-blue-300 mb-[1px]"
              onClick={() => {
                handleButtonClick("latest");
              }}
            >
              {">>"}
            </button>
          </div>

          {/* Row 1 */}
          <div className="lg:flex lg:flex-row mt-2">
            <p className=" lg:ml-2">Doc No:</p>
            <input
              className="w-20 text-right h-8 border border-black lg:ml-9 p-2 rounded-md focus:outline-none focus:border-blue-500"
              type="text"
              value={adviceNo}
              readOnly
            ></input>
            <button
              className="lg:flex items-center justify-center border border-black bg-[#002d62] text-white rounded-md px-3 py-1 lg:ml-2 mr-2    focus:outline-none focus:ring focus:border-blue-300"
              onClick={() => setShowDoc(true)}
            >
              ...
            </button>

            {showDoc && (
              <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 z-[100] bg-white border border-black lg:h-[400px] h-[80%] lg:w-[1000px] w-[95%] p-1 overflow-y-auto rounded-md">
                <div className="lg:flex lg:flex-row mt-2">
                  <p className="text-red-600 lg:ml-2">Search :</p>
                  <input
                    className="w-64 h-8 border border-black lg:ml-2 p-2 rounded-md focus:outline-none focus:border-blue-500"
                    type="text"
                    value={searchLoading}
                    onChange={(e) => setSearchLoading(e.target.value)}
                  ></input>
                  <p className="text-red-600 lg:ml-2">Start Date:</p>
                  <input
                    className="w-32 h-8 border border-black lg:ml-2 p-2 rounded-md focus:outline-none focus:border-blue-500"
                    type="date"
                    value={startDate?.split("T")[0]}
                    onChange={(e) => {
                      setStartDate(e.target.value);
                    }}
                  ></input>
                  <p className="text-red-600 lg:ml-2">End Date:</p>
                  <input
                    className="w-32 h-8 border border-black lg:ml-2 p-2 rounded-md focus:outline-none focus:border-blue-500"
                    type="date"
                    value={endDate?.split("T")[0]}
                    onChange={(e) => {
                      setEndDate(e.target.value);
                    }}
                  ></input>
                </div>

                <div className="visible lg:h-[430px] p-1 z-0 lg:overflow-auto mt-2">
                  <div className="flex justify-end gap-2">
                    <div className="cursor-pointer">
                      <RiFileExcel2Line onClick={ExcelStockData} size={25} />
                    </div>
                    <div className="cursor-pointer">
                      <BsFileEarmarkPdf onClick={PdfStockData} size={25} />
                    </div>
                  </div>
                  <table className="w-full border border-gray-300 text-sm table_1">
                    <thead className="sticky top-[-1px]">
                      <tr className="bg-[#2b3f5c] text-white text-[12px] table-header">
                        <td className="py-2 px-4 text-right border border-gray-300">
                          SNO
                        </td>
                        <td className="py-2 px-4 text-left border border-gray-300">
                          DOC NO
                        </td>
                        <td className="py-2 px-4 text-left border border-gray-300">
                          LOADING DATE
                        </td>
                        <td className="py-2 px-4 text-left border border-gray-300">
                          VEHICLE
                        </td>
                        <td className="py-2 px-4 text-left border border-gray-300">
                          DRIVER NAME
                        </td>
                        <td className="py-2 px-4 text-left border border-gray-300">
                          ORDER NO
                        </td>
                        <td className="py-2 px-4 text-left border border-gray-300">
                          DISPATCH LOCATIONS
                        </td>
                        <td className="py-2 px-4 text-left border border-gray-300">
                          DESTINATIONS
                        </td>
                        {/* <td className="py-2 px-4 text-left border border-gray-300">
                          DISPATCH LOCATION
                        </td> */}
                      </tr>
                    </thead>
                    <tbody>
                      {filteredRequest?.map((value, index) => {
                        const driver = driversList?.find(
                          (item) =>
                            item?.DRIVERCODE ===
                            value?.OT_LOADING_ADVISE_DRIVER_CODE,
                        );
                        return (
                          <tr
                            key={value?.OT_REQUEST_NO}
                            className="hover:bg-gray-100 cursor-pointer text-[13px]"
                            onClick={() => {
                              setAdviceNo(value.OT_LOADING_ADVISE_NO);
                              setAdviceDate(value.OT_LOADING_ADVISE_DATE);
                              setVehicleNo(value.OT_LOADING_ADVISE_VEHICLE_NO);
                              setReturnsPoNo(
                                value.OT_LOADING_ADVISE_CLIENT_PO_NO,
                              );
                              setIsCancelled(
                                value.OT_LOADING_ADVISE_CANCELLED === true
                                  ? true
                                  : false,
                              );
                              setSelLocations(
                                value?.OT_LOADING_ADVISE_FROM_MILL,
                              );
                              setSelDestination(
                                value?.OT_LOADING_ADVISE_PRODUCT_DESTINATION,
                              );
                              // OT_LOADING_ADVISE_DRIVER_CODE
                              setDriverCode(
                                value?.OT_LOADING_ADVISE_DRIVER_CODE,
                              );
                              const driver = driversList?.find(
                                (item) =>
                                  item?.DRIVERCODE ===
                                  value?.OT_LOADING_ADVISE_DRIVER_CODE,
                              );
                              setDriverName(driver?.DRIVERNAME);
                              getChildData(value.OT_LOADING_ADVISE_NO);
                              setHist(true)
                              setShowDoc(false);
                            }}
                          >
                            <td className="py-2 px-4 text-right border border-gray-300">
                              {index + 1}
                            </td>
                            <td className="py-2 px-4 text-right border border-gray-300">
                              {value.OT_LOADING_ADVISE_NO || "N/A"}
                            </td>
                            <td className="py-2 px-4 text-left border border-gray-300">
                              {value.OT_LOADING_ADVISE_DATE
                                ? moment(value.OT_LOADING_ADVISE_DATE).format(
                                    "DD/MM/YYYY",
                                  )
                                : ""}
                            </td>
                            <td className="py-2 px-4 text-left border border-gray-300">
                              {value.OT_LOADING_ADVISE_VEHICLE_NO || "N/A"}
                            </td>
                            <td className="py-2 px-4 text-left border border-gray-300">
                              {driver?.DRIVERNAME || "N/A"}
                            </td>
                            <td className="py-2 px-4 text-left border border-gray-300">
                              {value.OT_LOADING_ADVISE_CLIENT_PO_NO || "N/A"}
                            </td>
                            <td className="py-2 px-4 text-left border border-gray-300">
                              {value.OT_LOADING_ADVISE_FROM_MILL || "N/A"}
                            </td>
                            <td className="py-2 px-4 text-left border border-gray-300">
                              {value.OT_LOADING_ADVISE_PRODUCT_DESTINATION ||
                                "N/A"}
                            </td>
                            {/* <td className="py-2 px-4 text-left border border-gray-300">
                            {value.OT_LOADING_ADVISE_FROM_MILL || "N/A"}
                          </td> */}
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                </div>

                <button
                  className="absolute top-2 right-2 lg:flex items-center justify-center border border-black bg-[#002d62] text-white rounded-md px-3 py-1 lg:ml-2 mr-2    focus:outline-none focus:ring focus:border-blue-300"
                  onClick={() => setShowDoc(false)}
                >
                  Close
                </button>
              </div>
            )}

            <p className=" lg:ml-2">Loading Date:</p>
            <input
              className="w-32 h-8 border border-black lg:ml-2 p-2 rounded-md focus:outline-none focus:border-blue-500"
              type="date"
              value={adviceDate?.split("T")[0]}
              onChange={(e) => setAdviceDate(e.target.value)}
            ></input>

            {/* <p className=" lg:ml-2">Date :</p>
            <input
              className="w-32 h-8 border border-black lg:ml-2 p-2 rounded-md focus:outline-none focus:border-blue-500"
              type="date"
              value={date?.split("T")[0]}
              readOnly
            ></input> */}

            <p className=" lg:ml-36">Loading Time :</p>
            <input
              className="w-32 h-8 border border-black lg:ml-2 p-2 rounded-md focus:outline-none focus:border-blue-500"
              type="text"
              value={currentTime}
              readOnly
            ></input>

            <input
              className="w-4 h-4 lg:ml-6 lg:mt-1"
              type="checkbox"
              checked={forRawMaterials}
              onChange={() => setForRawMaterials(!forRawMaterials)}
            ></input>
            <p className="lg:ml-2">For Raw Materials</p>
          </div>

          {/* Row 2 */}
          <div className="lg:flex lg:flex-row mt-2">
            <p className=" lg:ml-2 mr-1">Vehicle :</p>
            <input
              className="w-32 h-8 border border-black lg:ml-8 p-2 rounded-md focus:outline-none focus:border-blue-500"
              type="text"
              value={vehicleNo}
              readOnly
            ></input>

            <p className=" lg:ml-2 lg:mr-2">Driver :</p>
            <Select
              className="lg:w-64 w-64 lg:ml-12"
              menuPortalTarget={document.body}
              styles={{
                menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                menu: (base) => ({ ...base, zIndex: 9999 }),
              }}
              value={
                driverName
                  ? { value: driverName, label: driverName }
                  : { value: "", label: "Select Driver" }
              }
              onChange={(e) => {
                setDriverName(e.label);
                setDriverCode(e.value);
              }}
              options={[
                { value: "", label: "Select Driver" },
                ...driversList?.map((item) => ({
                  value: item.DRIVERCODE,
                  label: item.DRIVERNAME,
                })),
              ]}
            ></Select>

            <p className=" lg:ml-3">Destination :</p>
            <Select
              className="lg:w-80 w-64 lg:ml-6"
              isMulti
              options={[
                { value: "", label: "Select Destination" },
                ...destinationOptions,
              ]}
              onChange={handleDestinationChange}
              value={destinationOptions.filter((option) =>
                selDestination.includes(option.value),
              )}
              menuPortalTarget={document.body}
              styles={{
                menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                menu: (base) => ({ ...base, zIndex: 9999 }),
              }}
            ></Select>
          </div>

          {/* Row 3 */}
          {forRawMaterials === false && (
            <>
              <div className="lg:flex lg:flex-row mt-2">
                <p className="lg:ml-2">Order No:</p>
                <input
                  className="w-44 h-8 border text-right border-black lg:ml-6 p-2 rounded-md focus:outline-none focus:border-blue-500"
                  type="text"
                  value={returnsPoNo}
                  onChange={(e) => setReturnsPoNo(e.target.value)}
                ></input>

                <p className="lg:ml-3">Dispatch Location :</p>
                <Select
                  menuPortalTarget={document.body}
                  styles={{
                    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                    menu: (base) => ({ ...base, zIndex: 9999 }),
                  }}
                  isMulti
                  options={[
                    { value: "", label: "Select Location" },
                    ...locationOptions,
                  ]}
                  onChange={handleSelectChange}
                  value={locationOptions.filter((option) =>
                    selLocations.includes(option.value),
                  )}
                  className="min-w-[500px] lg:ml-2"
                />
              </div>
            </>
          )}

          <div className="flex justify-center mt-5">
            <button
              className="absolute top-2 right-72 lg:flex items-center justify-center border border-black bg-[#002d62] text-white rounded-md px-3 py-1 lg:ml-2 mr-2    focus:outline-none focus:ring focus:border-blue-300"
              onClick={async () => {
                const isDispatched = dispatchData?.find((item)=>item?.OT_DISPATCH_LOADING_ORDER_NO == returnsPoNo)
                if (isDispatched) {
                  alert("This Loading Order No is already Dispatched, can not cancel")
                  return;
                }

                if (lastAdviceNo === adviceNo) {
                  alert("Kindly Select the Saved Doc No");
                  return;
                }
                await CancelLoading();
                setShowGateIn(false);
                window.location.reload();
              }}
            >
              CANCEL
            </button>

            <button
              className="absolute top-2 right-20 lg:flex items-center justify-center border border-black bg-[#002d62] text-white rounded-md px-3 py-1 lg:ml-2 mr-2    focus:outline-none focus:ring focus:border-blue-300"
              onClick={async () => {
                if (!adviceDate) {
                  alert("Kindly Supply Advice Date");
                  return;
                } else if (forRawMaterials === false && !returnsPoNo) {
                  alert("Kindly Supply Order No");
                  return;
                } else if (selDestination.length === 0) {
                  alert("Kindly Supply Destination");
                  return;
                } else if (
                  forRawMaterials === false &&
                  selLocations.length === 0
                ) {
                  alert("Kindly Select Dispatch Location");
                  return;
                } else if (isCancelled === true) {
                  alert("This Document is Cancelled");
                  return;
                }
                await getNewId();
                await SaveGateIn();
                setShowGateIn(false);
                window.location.reload();
              }}
            >
              PROCEED FOR LOADING
            </button>
          </div>

          <button
            className="absolute top-2 right-2 lg:flex items-center justify-center border border-black bg-[#002d62] text-white rounded-md px-3 py-1 lg:ml-2 mr-2    focus:outline-none focus:ring focus:border-blue-300"
            onClick={() => setShowGateIn(false)}
          >
            Close
          </button>
        </div>
      )}
    </div>
  );
};

export default ListOfTrucksReadyForLoading;
